import { Grid } from "@material-ui/core"
import React from "react"
import {
  StyledDetailHeader,
  StyledDetailLocation,
  StyledDetailSubheader,
  StyledDetailSubheaderContent,
} from "./MapTypography"
import { Image } from "react-image-and-background-image-fade"
import sunseap_logo from "../../images/sunseap-logo.png"
import sustainable_cities from "../../images/sustainble-cities-and-communities.png"
import affordable_clean_energy from "../../images/affordable-and-clean-energy.png"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"

const StyledLogoWrapper = styled.div`
  width: 50%;
  margin-bottom: 5%;

  ${breakpoint.md} {
    width: 40%;
  }
`

const StyledInvestmentThemeWrapper = styled.div`
  width: 100%;
  border-bottom: 2px solid #0f6494;
  padding-top: 8px;
  padding-bottom: 8px;

  ${breakpoint.lg} {
    border-bottom: 3px solid #0f6494;
    padding-top: 12px;
    padding-bottom: 12px;
  }
`

const SunseapMapDetailMobile = () => {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <StyledLogoWrapper>
            <Image
              src={sunseap_logo}
              width="956px"
              height="252px"
              isResponsive
              disableLoader
              alt="Sunseap"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </StyledLogoWrapper>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <div style={{ marginBottom: "1%" }}>
          <StyledDetailHeader>Solar Energy</StyledDetailHeader>
        </div>
      </Grid>
      <Grid item xs={12}>
        <StyledDetailLocation>Based in Singapore</StyledDetailLocation>
      </Grid>
      <Grid container>
        <Grid item xs={12} container alignItems="center">
          <StyledInvestmentThemeWrapper>
            <Grid item xs={12}>
              <div style={{ marginBottom: "1%" }}>
                <StyledDetailSubheader>Investment Theme</StyledDetailSubheader>
              </div>
            </Grid>
            <Grid item xs={12}>
              <StyledDetailSubheaderContent>
                Climate & Water Solutions
                <br />
                Smart & Liveable Cities
              </StyledDetailSubheaderContent>
            </Grid>
          </StyledInvestmentThemeWrapper>
        </Grid>
        <Grid item xs={12}>
          <StyledDetailSubheader style={{ marginTop: "16px" }}>
            About the Company
          </StyledDetailSubheader>
          <StyledDetailSubheaderContent>
            Largest and most established clean energy solutions provider in
            Singapore, with regional operations in Asia.
          </StyledDetailSubheaderContent>
          <StyledDetailSubheader style={{ marginTop: "16px" }}>
            Impact Thesis
          </StyledDetailSubheader>
          <StyledDetailSubheaderContent>
            Powering homes and businesses with clean energy and reducing GHG
            emissions.
          </StyledDetailSubheaderContent>
        </Grid>
      </Grid>
      <div style={{ width: "100%", marginTop: "10%" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Image
              src={affordable_clean_energy}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="affordable and clean energy"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
          <Grid item xs={3}>
            <Image
              src={sustainable_cities}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="sustainble cities and communities"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default SunseapMapDetailMobile
